import Axios from '../utils/axios-utils';

// uplaod media
export const uploadMedia = async (accountId, file, linkedType, linkedId, context) => {
    try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('linkedType', linkedType);
        formData.append('linkedId', linkedId);
        formData.append('context', context);

        const response = await Axios.post(`/accounts/${accountId}/media/upload`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Upload Media error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Media upload failed" },
        };
    }
};

// delete media
export const deleteMedia = async (accountId, mediaId) => {
    try {
        const response = await Axios.delete(`/accounts/${accountId}/media/${mediaId}`);

        return {
            success: response.data.status === 'success',
            data: response.data,
            status: response.status
        };
    } catch (error) {
        console.error("Delete Media error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Media delete failed" },
            status: error.response?.status || 500
        };
    }
};